import { render, staticRenderFns } from "./UserFilterTab.vue?vue&type=template&id=00b6934d&scoped=true"
import script from "./UserFilterTab.vue?vue&type=script&lang=js"
export * from "./UserFilterTab.vue?vue&type=script&lang=js"
import style0 from "./UserFilterTab.vue?vue&type=style&index=0&id=00b6934d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b6934d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00b6934d')) {
      api.createRecord('00b6934d', component.options)
    } else {
      api.reload('00b6934d', component.options)
    }
    module.hot.accept("./UserFilterTab.vue?vue&type=template&id=00b6934d&scoped=true", function () {
      api.rerender('00b6934d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderViewConfig/components/UserFilterTab.vue"
export default component.exports